// extracted by mini-css-extract-plugin
export var originalPrice = "_uv-0";